import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleSuccess } from '../utils';
import { ToastContainer } from 'react-toastify';
import AppButton from '../components/AppButton';

function Home() {
    const [loggedInUser, setLoggedInUser] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        setLoggedInUser(localStorage.getItem('loggedInUser'));
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('loggedInUser');
        handleSuccess('User logged out');
        setTimeout(() => {
            navigate('/login');
        }, 1000);
    };

    return (
        <div className='container'>
            <h1>Welcome {loggedInUser}</h1>
            <p>Your account is verified and you are logged in.</p>
            <AppButton onClick={handleLogout}>Logout</AppButton>
            <ToastContainer />
        </div>
    );
}

export default Home;
